import request from '@/utils/request'


// 공사기간별 일반결제내역 조회
export function getNormalTossSettlementFromOrderHistory (params, isNotify) {
  return request({
    url: `/api/getNormalTossSettlementFromOrderHistory`,
    method: 'GET',
    params: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 공사기간별 정액결제내역 조회
export function getBillingTossSettlementFromOrderHistory (params, isNotify) {
  return request({
    url: `/api/getBillingTossSettlementFromOrderHistory`,
    method: 'GET',
    params: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 토스 카드결제 내역 조회
export function getTossSettlementHistory (params, isNotify) {
  return request({
    url: `/api/getTossSettlementHistory`,
    method: 'GET',
    params: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 직접계좌이체 내역 조회
export function getSettlementHistory (params, isNotify) {
  return request({
    url: `/api/getSettlementHistory`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 월별 정산 요약 - 수정본
export function getMonthlySettlementSummary (params, isNotify) {
  return request({
    url: `/api/getMonthlySettlementSummary`,
    method: 'GET',
    params: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 품목별 정산 요약 조회
export function getMonthlyItemSettlementSummary (params, isNotify) {
  return request({
    url: `/api/getMonthlyItemSettlementSummary`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}